import React, { useRef } from "react";
import styled from "styled-components";
import testprofil from "../assets/testprofil.jpg";
import Appear from "../animations/Appear";
import AnimateFromUp from "../animations/AnimateFromUp";
import SkillsAnimate from "../animations/navbarAnimations/SkillsAnimate";
import ProjectAnimate from "../animations/navbarAnimations/ProjectAnimate";
import AboutAnimate from "../animations/navbarAnimations/AboutAnimate";
import ContactAnimate from "../animations/navbarAnimations/ContactAnimate";

interface HeaderProps {
  skillsRef: React.RefObject<HTMLDivElement>;
  projectsRef: React.RefObject<HTMLDivElement>;
  aboutRef: React.RefObject<HTMLDivElement>;
  contactRef: React.RefObject<HTMLDivElement>;
  scrollToRef: (ref: React.RefObject<HTMLDivElement>) => void;
}

export default function Header({
  skillsRef,
  projectsRef,
  aboutRef,
  contactRef,
  scrollToRef,
}: HeaderProps) {
  return (
    <Wrapper>
      <AnimateFromUp>
        <Name>
          <h1>Kamil Wójciak</h1>
          <h3>Junior Frontend Developer</h3>
        </Name>
      </AnimateFromUp>
      <NavbarContainer>
        <AnimateFromUp>
          <NavbarImg src={testprofil} alt="Profile" />
        </AnimateFromUp>
        <Appear>
          <NavList>
            <NavItem
              onClick={() => {
                skillsRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <SkillsAnimate>
                <NavLink>Skills</NavLink>
              </SkillsAnimate>
            </NavItem>
            <NavItem
              onClick={() => {
                projectsRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <ProjectAnimate>
                <NavLink>Projects</NavLink>
              </ProjectAnimate>
            </NavItem>
            <NavItem
              onClick={() => {
                aboutRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <AboutAnimate>
                <NavLink>About</NavLink>
              </AboutAnimate>
            </NavItem>
            <NavItem
              onClick={() => {
                contactRef.current?.scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                  inline: "nearest",
                });
              }}
            >
              <ContactAnimate>
                <NavLink>Contact</NavLink>
              </ContactAnimate>
            </NavItem>
          </NavList>
        </Appear>
      </NavbarContainer>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  max-height: 100%;
  position: relative;
`;

const Name = styled.div`
  color: white;
  transition: all 150ms ease-in-out;
  position: absolute;
  left: 200px;
  top: 0px;

  font-size: 1.2rem;
  @media (max-width: 570px) {
    & > h1 {
      font-size: 1.3rem;
    }
    & > h3 {
      font-size: 1rem;
    }
  }
  @media (min-width: 1054px) {
    left: 260px;
  }

  @media (min-width: 1201px) {
    left: 330px;
    & > h1 {
      font-size: 2.5rem;
    }
    & > h3 {
      font-size: 1.6rem;
    }
  }
  @media (max-width: 460px) {
    top: -15px;
    left: 35px;
    & > h1 {
      color: white;
    }
    & > h1::after {
      disaply: none;
      // content: "Portfolio";
      // color: white;
      // font-size: 1rem;
      // width: 125px;
      // top: 3px;
      // left: 150px;
      // position: absolute;
      // text-align: center;
    }
    & > h3 {
      display: none;
    }
  }
`;

const NavbarContainer = styled.nav`
  max-width: 100%;
  height: auto;
  margin-top: 16px;
  margin-right: 16px;
  margin-left: 20px;
  display: flex;
  border-radius: 30px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  align-items: center;
  // border: 14px solid rgba(185, 185, 185, 0.44);
`;

const NavList = styled.ul`
  list-style: none;
  display: flex;
  gap: 35px;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  font-style: oblique;
  margin-right: 23px;

  @media (max-width: 769px) {
    flex-direction: column;
    gap: 5px;
    margin-top: 75px;
    margin-bottom: 10px;
  }
  @media (max-width: 460px) {
    margin-top: 65px;
    margin-bottom: 65px;
  }
`;

const NavItem = styled.li`
  position: relative;
`;

const NavLink = styled.a`
  color: white;
  text-decoration: none;
  font-size: 1.2rem;
  text-transform: uppercase;
  opacity: 1;
  transition: all 150ms ease-in-out;
  position: relative;
  margin: 15px;
  border: none;
  outline: none;
  overflow: hidden;
  backface-visibility: hidden;
  cursor: pointer;

  @media (min-width: 1054px) {
    font-size: 2rem;
    font-weight: bold;
  }
  @media (max-width: 1053px) {
    font-size: 1.5rem;
    font-weight: bold;
    margin: 0px;
  }
  @media (max-width: 769px) {
    font-size: 1.2rem;
    font-weight: bold;
    margin: 0;
  }

  &:hover {
    color: rgba(82, 233, 250, 0.8);
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    overflow: hidden !important;
    backface-visibility: hidden;

    &::after {
      transform: scaleX(1);
    }
  }

  &::after {
    content: "";
    display: block;
    height: 5px;
    background: rgba(82, 233, 250, 0.8);
    position: absolute;
    bottom: -0.3em;
    left: 0;
    right: 0;
    transform: scaleX(0);
    transition: transform ease-in-out 250ms;
    border: none;
    outline: none;
  }
`;

const NavbarImg = styled.img`
  width: 150px;
  height: auto;
  opacity: 1;
  display: flex;
  align-items: flex-start;
  margin-left: 16px;
  margin-right: 8px;
  border-radius: 7px;
  border: 2px solid rgba(255, 255, 255, 1);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.5);
  transition: all 150ms ease-in-out;

  @media (min-width: 1054px) {
    width: 200px;
  }

  @media (min-width: 1201px) {
    width: 260px;
  }

  @media (max-width: 460px) {
    width: 120px;
  }
`;
